// компонент отвечающий за рендеринг приложения, представляет из себя контейнер, который привязан к роуту, используется для раздление логики  (например различные виды кабинетов)
import React from 'react';
import { connect } from 'react-redux';
import M2Store from '../library/M2Store';



class Application extends React.Component {

	componentDidMount() {
		let path = window.location.pathname;
		let token = M2Store.get('access_token');

		if(path != '/' && !token) {
			window.location.href = '/';//redirect to login page
		}
	}

	render() {
		const { children } = this.props;
		return (
			<div className="m2AppContainer">
				{children}
			</div>
		);
	}
}



const mapStateToProps = (state, ownProps) => ({
	errorMessage: state.errorMessage,
	inputValue: ownProps.location.pathname.substring(1)
});

export default connect(mapStateToProps)(Application);


// WEBPACK FOOTER //
// ./src/containers/Application.js